import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {ProjectService, ProjectTypeService} from '../../services';
import {FormUtil} from '../../utils';
import {ProjectType} from "../../models/project-analysis";

@Component({
    selector: 'app-change-project-type-modal',
    templateUrl: './change-project-type-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeProjectTypeModalComponent {
    private projectService = inject(ProjectService);
    public modalRef = inject(VwuiModalRef);
    public readonly modalConfig = inject<VwuiModalConfig<{ projectId: number, projectTypeId: number | undefined }>>(VwuiModalConfig);
    private projectTypeService = inject(ProjectTypeService);

    public form = new UntypedFormGroup({
        projectTypeId: new UntypedFormControl(this.modalConfig.data.projectTypeId, Validators.required),
    });

    public loading = false;
    public readonly projectTypes = toSignal(this.projectTypeService.list(), {initialValue: [] as ProjectType[]});

    async submit() {
        this.loading = true;
        try {
            FormUtil.validate(this.form);
            const notSameId = this.form.value.projectTypeId !== this.modalConfig.data.projectTypeId;
            if (this.form.valid && notSameId) {
                const updatedProject = await this.projectService.changeProjectType(this.modalConfig.data.projectId, this.form.value.projectTypeId);
                this.modalRef.close(updatedProject);
            }
        } finally {
            this.loading = false;
        }
    }
}
